import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { Popover, WatchClickOutside } from 'components';
import { LLSocialAccountChip } from 'components/FormElements';
import * as styles from '../ContentChannelRow/StarPopover.scss';
import { connect } from 'react-redux';
import { deleteAccountFromTag, favoriteChannel, unFavoriteChannel } from 'redux/modules/contentLibrary';
var StarPopover = (_dec = connect(function (state) {
  return {
    addingSAInProgress: state.contentLibrary.addingSAInProgress,
    organization: state.organization.current,
    unfavoriting: state.contentLibrary.unfavoriting,
    theme: state.theme
  };
}, {
  deleteAccountFromTag: deleteAccountFromTag,
  favoriteChannel: favoriteChannel,
  unFavoriteChannel: unFavoriteChannel
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(StarPopover, _Component);

  var _super = _createSuper(StarPopover);

  function StarPopover(props) {
    var _this;

    _classCallCheck(this, StarPopover);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDeleteSocialAccountChip", function (sa) {
      var removeIndex = -1;

      _this.state.currentSelectedAccounts.forEach(function (ssa, idx) {
        if (sa.id === ssa.id) {
          removeIndex = idx;
        }
      });

      if (removeIndex !== -1) {
        var subCopy = [].concat(_this.state.currentSelectedAccounts);
        subCopy.splice(removeIndex, 1);

        _this.setState({
          currentSelectedAccounts: subCopy
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAddSocialAccountSelected", function () {
      _this.setState({
        addButtonShown: !_this.state.addButtonShown
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeSocialAccountSubscriptions", function () {
      var accountIds = _this.state.currentSelectedAccounts ? _this.state.currentSelectedAccounts.map(function (a) {
        return a.id;
      }) : [];

      _this.props.deleteAccountFromTag(_this.props.organization.id, accountIds, _this.props.tagId).then(function () {
        _this.props.reloadQueues();

        _this.props.unFavoriteChannel(_this.props.tagId, _this.props.organization.id, _this.props.channelName).then(function () {
          return _this.setState({
            showUnsubscribeDialog: false
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitSocialAccountSubscriptions", function () {
      var accountIds = _this.state.currentSelectedAccounts ? _this.state.currentSelectedAccounts.map(function (a) {
        return a.id;
      }) : [];

      _this.props.subscribeAccountsToTag(_this.props.organization.id, accountIds, _this.props.tagId).then(function () {
        _this.setState({
          showSubscribeDialog: false
        });

        _this.props.reloadQueues();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "subscribeSocialAccount", function (sa) {
      var subCopy = [].concat(_this.state.currentSelectedAccounts);
      subCopy.push(sa);

      _this.setState({
        currentSelectedAccounts: subCopy
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubscribeDialogBody", function () {
      var hasSA = _this.props.socialAccounts.length > 0;
      var selectedSocialAccountChips = _this.state.currentSelectedAccounts ? _this.state.currentSelectedAccounts.map(function (sa) {
        return /*#__PURE__*/React.createElement(LLSocialAccountChip, {
          key: sa.id,
          socialAccount: sa,
          style: {
            "float": 'left',
            margin: '3px'
          },
          requestDelete: _this.onDeleteSocialAccountChip.bind(_assertThisInitialized(_this), sa)
        });
      }) : null;
      var unsubscribedSocialAccounts = [];

      _this.props.socialAccounts.forEach(function (sa) {
        var isSubed = false;

        if (_this.state.currentSelectedAccounts) {
          _this.state.currentSelectedAccounts.forEach(function (subSa) {
            if (subSa.id === sa.id) {
              isSubed = true;
            }
          });
        }

        if (!isSubed) {
          unsubscribedSocialAccounts.push(sa);
        }
      });

      var unselectedSocialAccountChips = unsubscribedSocialAccounts.map(function (sa) {
        return /*#__PURE__*/React.createElement(LLSocialAccountChip, {
          key: sa.id,
          socialAccount: sa,
          onClick: _this.subscribeSocialAccount.bind(_assertThisInitialized(_this), sa),
          style: {
            "float": 'left',
            margin: '3px',
            opacity: 0.5,
            cursor: 'pointer'
          }
        });
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, hasSA ? "Would you like to add content from ".concat(_this.props.channelName, " to one of your queues?") : "Once you add a social account, you can add\n                ".concat(_this.props.channelName, " content to a queue that will post for you.")), !hasSA && /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Add A Social Account",
        onClick: function onClick() {
          browserHistory.push("/org/".concat(_this.props.organization.id, "/settings/social-accounts"));
        }
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: styles.oswaldHeader
      }, "Selected queues"), selectedSocialAccountChips, selectedSocialAccountChips.length === 0 && /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, "No queues selected.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: styles.oswaldHeader
      }, "Available queues"), unselectedSocialAccountChips, unselectedSocialAccountChips.length === 0 && /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, "You've added ", _this.props.channelName, " content to all of your queues.")))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderUnsubscribeDialogBody", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, _this.state.currentSelectedAccounts.length > 0 ? "You are about to remove\n                ".concat(_this.props.channelName, " from your favorites and remove all of it's content from your queues.") : "You are about to remove\n                ".concat(_this.props.channelName, " from your favorites.")))));
    });

    _defineProperty(_assertThisInitialized(_this), "removeSocialAccounts", function () {
      if (_this.state.currentSelectedAccounts.length > 0) {
        _this.removeSocialAccountSubscriptions();
      } else {
        _this.props.unFavoriteChannel(_this.props.tagId, _this.props.organization.id, _this.props.channelName).then(function () {
          _this.setState({
            showUnsubscribeDialog: false
          });

          _this.props.reloadQueues();
        });
      }
    });

    _this.state = {
      showUnsubscribeDialog: false,
      showSubscribeDialog: false,
      addButtonShown: true,
      currentSelectedAccounts: []
    };
    return _this;
  }

  _createClass(StarPopover, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!nextProps.addingSAInProgress) {
        this.setState({
          currentSelectedAccounts: nextProps.selected && nextProps.selected.social_accounts ? nextProps.selected.social_accounts : []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var unsubscribeDialogActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this2.setState({
            showUnsubscribeDialog: false
          });
        },
        disabled: this.props.unfavoriting,
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: this.props.unfavoriting ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spin fa-spinner",
          style: {
            fontSize: 20
          }
        }) : 'Remove From Favorites',
        onClick: this.removeSocialAccounts,
        disabled: this.props.unfavoriting
      })];
      var subscribeDialogActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginRight: 24
        },
        label: "Not Now",
        onClick: function onClick() {
          return _this2.setState({
            showSubscribeDialog: false
          });
        },
        disabled: this.props.addingSAInProgress
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: this.props.addingSAInProgress ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spin fa-spinner",
          style: {
            fontSize: 20
          }
        }) : 'Add',
        onClick: this.submitSocialAccountSubscriptions,
        disabled: this.props.addingSAInProgress
      })];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline',
          cursor: 'pointer'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline'
        },
        onClick: function onClick() {
          if (!_this2.props.selected) {
            _this2.props.favoriteChannel(_this2.props.tagId, _this2.props.organization.id, _this2.props.channelName);

            _this2.setState({
              showSubscribeDialog: true
            });
          } else {
            _this2.setState({
              showUnsubscribeDialog: true
            });
          }
        }
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "icon ".concat(styles.star, " ").concat(this.props.selected ? 'ion-ios-star' : 'ion-ios-star-outline'),
        style: {
          color: this.props.theme.colors.primaryColor
        }
      }))), /*#__PURE__*/React.createElement(Dialog, {
        actions: this.props.socialAccounts.length > 0 ? subscribeDialogActions : [],
        open: this.state.showSubscribeDialog,
        title: "We've Added\n            ".concat(this.props.channelName, " To Your Favorites")
      }, /*#__PURE__*/React.createElement("div", null, this.renderSubscribeDialogBody())), /*#__PURE__*/React.createElement(Dialog, {
        actions: unsubscribeDialogActions,
        open: this.state.showUnsubscribeDialog,
        title: 'Are You Sure?'
      }, /*#__PURE__*/React.createElement("div", null, this.renderUnsubscribeDialogBody())));
    }
  }]);

  return StarPopover;
}(Component), _defineProperty(_class2, "defaultProps", {
  subscribedSocialAccounts: []
}), _temp)) || _class);
export { StarPopover as default };